module.exports = __webpack_public_path__ + "static/media/i2.e65ef5b2.png";